import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { RejectReasonComponent } from '../reject-reason/reject-reason.component';
import * as FileSaver from 'file-saver';
import { DescriptionDetailsComponent } from '../description-details/description-details.component';

@Component({
  selector: 'app-corporate-approval',
  templateUrl: './corporate-approval.component.html',
  styleUrls: ['./corporate-approval.component.css'],
})
export class CorporateApprovalComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'phone',
    'email',
    'reason',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private saveApi = environment.url + environment.corporateApprovalSave;
  private listApi = environment.url + environment.corporateApprovalList;
  private corporateExcelDownload =
    environment.url + environment.corporateExcelDownload;
  private removeApi = environment.url + environment.corporteRemove;
  /**
   * Constructs a new instance of the CorporateApprovalComponent
   * @param makeapi API service provider
   * @param getdata Value service provider
   * @param notify Notification service provider
   * @param dialog Material dialog service provider
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data
     */
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * Initializes the component by setting the role value and fetching the incubatee list.
   */
  ngOnInit(): void {
    // Set the visibility of the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Initialize the flag to indicate if data is available
    this.noData = false;

    // Fetch the list of incubatees
    this.incubatorList();
  }
  /**
   * Approves an incubator
   * @param id The ID of the incubator to be approved
   */
  approvalIncubator(id: number): void {
    const req = {
      userid: id,
      status: 1,
    };

    /**
     * Sends a POST request to the approval API
     * and passes the request object as the body
     */
    this.makeapi.method(this.saveApi, req, 'post').subscribe((data) => {
      if (data.responseStatus === 'Success') {
        /**
         * Displays a success notification with the response message
         */
        this.notify.notifysuccess(data.responseMessage);
        /**
         * Refreshes the list of incubatees
         */
        this.incubatorList();
        /**
         * Shows the loading indicator
         */
        this.getdata.isVisibleSource.next(true);
      } else {
        /**
         * Displays an error notification with the response message
         */
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  status = 0;
  noData = true;
  /**
   * Sets the status value and fetches the list of incubatees
   * @param val The value of the status to be set
   */
  incubatorCheck(data): void {
    // Set the status value
    this.status = data;

    // Fetch the list of incubatees
    this.incubatorList();

    // Reset the page number and page size
    this.pageNumber = 1;
    this.pageSize = 25;
  }
  /**
   * Fetches the list of incubatees based on pagination and status.
   * Shows a loading indicator while the API request is in progress.
   * Updates the component data with the response from the API.
   * Sets the noData flag if no data is returned.
   */
  incubatorList() {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API call to fetch the incubatee list
    return this.makeapi
      .method(
        `${this.listApi}?listSize=${this.pageSize}&pageNumber=${this.pageNumber}&status=${this.status}`,
        '',
        'get'
      )
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');

        // Check if there is no data returned
        if (data.count === 0) {
          this.noData = true;
        } else {
          // Data is available
          this.noData = false;
          // Update the total count of pages
          this.pageTotalCount = data.count;
          // Update the list of incubatees
          this.disList = data.responseUserModelList;
          // Set the MatTableDataSource with the list of incubatees
          this.dataSource = new MatTableDataSource(data.responseUserModelList);
        }
      });
  }
  /**
   * Initializes the paginator after the component view has been initialized.
   * Called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Called when the user paginates the table
   * @param event The pagination event
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Fetch the list of incubatees based on pagination and status
    this.incubatorList();
  }
  /**
   * Opens the RejectReason dialog and handles the result.
   * @param id The ID of the incubator to reject.
   */
  rejectReason(id) {
    // Open the RejectReason dialog with specific configurations
    const dialogRef = this.dialog.open(RejectReasonComponent, {
      width: '390px',
      data: { _id: id },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the list of incubatees
      this.incubatorList();
      // Notify that data visibility has been updated
      this.getdata.isVisibleSource.next(true);
    });
  }
  /**
   * Downloads the corporate list as an Excel file.
   * Shows a loading indicator during the request and hides it once the file is downloaded.
   * The file is saved with a name based on the current date and time.
   * @param name The name of the corporate list
   * @param value The value of the corporate list to be downloaded
   */
  downloadExcel(name: string, value: string) {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to download the Excel file
    this.makeapi
      .method(this.corporateExcelDownload + value, '', 'download')
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Generate the current date and time for the filename
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getSeconds()}`;

        // Define the filename with the current date and time
        let filename =
          'StartupTN_Corporators_' + name + '_' + currentDate + '.xlsx';

        // Save the downloaded file using FileSaver
        FileSaver.saveAs(data, filename);
      });
  }
  /**
   * Deletes a corporate list.
   * @param id The ID of the corporate list to be deleted.
   */
  deleteList(id: number) {
    // Make API call to delete the corporate list
    this.makeapi.method(this.removeApi + id, '', 'delete').subscribe((data) => {
      // Check if the response status is 'Success'
      if (data.responseStatus === 'Success') {
        // Notify the user of the deletion
        this.notify.notifysuccess(data.responseMessage);
        // Refresh the list of corporate lists with the status of 'Deleted'
        this.incubatorCheck('2');
      } else {
        // Notify the user of the error
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  /**
   * Opens the DescriptionDetails dialog and handles the result.
   * @param status The status associated with the description.
   * @param title The title of the description.
   */
  viewDescrptionBtn(status: string, title: string) {
    // Open the DescriptionDetails dialog with the provided status and title
    const dialogRef = this.dialog.open(DescriptionDetailsComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
